import admin from "./admin";
import auth from "./auth";
import challenges from "./challenges";
import entry from "./entry";
import messages from "./messages";
import organisations from "./organisations";
import user from "./user";

const actions = {
  auth,
  user,
  messages,
  organisations,
  challenges,
  admin,
  entry,
};
export default actions;
